import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';
// import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import store from './store';

import 'react-toastify/dist/ReactToastify.min.css';

import App from './Components/App';
import {
  Login,
  Home,
  NotFound,
  Venda
} from './Views';

ReactDOM.render(
  <Provider store={store}>
    <Router history={ browserHistory }>
      <Route path="/login" component={Login} />

      <Route exact path="/" component={App}>
        <IndexRoute component={Home} />
        <Route path="/venda" component={Venda} />
      </Route>
      <Route path="*" component={NotFound} />
    </Router>
  </Provider>,
  document.getElementById('root')
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js